import React from 'react';

import Dim from 'web/components/common/modal/common/Dim';
import * as input from 'web/components/common/modal/common/input';
import CloseBtn from 'web/components/common/modal/common/CloseBtn';

import classNames from 'classnames/bind';
import styles from './Consultation.scss';
const cx = classNames.bind(styles);

const Consultation = React.memo(
  ({
    user,
    userName,
    phoneNumber,
    agree,
    error,
    handleChange,
    handleSubmit,
    handlePopup,
    handleCheckbox,
    data = {},
  }) => {
    // const { handlePopup = {}, error = { email: '', password: '' } } = props;
    // const error = { username: '', password: '' };

    // console.log(`@#$#@#@#$#@#$#@`);
    // console.log(user.tmTitle.replace('\\n', '\n').replace('\n', '<br/>'));
    console.log({ modal: data });

    if (user.userPurchase === 'STANDING') {
      return (
        <Dim>
          <div
            className={cx('Consultation', user.userPurchase)}
            onClick={e => e.stopPropagation()}
          >
            <div className="standing-message">
              <h3>어학기 연동이 필요합니다.</h3>
              어학기에서 로그인하시면, <br />
              모든 학습 기능을 이용하실 수 있습니다.
            </div>
            <input.BottomButton
              type={'submit'}
              msg={``}
              onClick={handlePopup.close}
              buttonStyle={{ backgroundColor: '#9576ea', color: '#fff' }}
            >
              닫기
            </input.BottomButton>
          </div>
        </Dim>
      );
    }

    let message = {
      checkbox: `오케이닥터 상담 신청을 위한<br/><span class="link">개인정보 수집 및 이용</span>에 동의합니다.`,
      submit: user.tmBtnText,
      title: user.tmTitle,
    };

    if (data.landing) {
      message.checkbox = `<span class="link">개인정보 수집 및 이용</span>에 동의합니다.`;
      message.submit = `신청하기 >`;
      message.title = `지금 전화 상담을 신청하시면\n친절한 학습 상담을 무료로 받아보실 수 있어요!`;
    }

    return (
      <Dim>
        <div
          className={cx(
            'Consultation',
            user.type === 'GUEST' ? 'login' : '',
            data.landing ? 'landing' : '',
          )}
          onClick={e => e.stopPropagation()}
        >
          <form>
            {!data.landing ? (
              user.userPurchase === 'NONE' ? (
                <>
                  <div className="popup-guide login">
                    로그인 후 이용하실 수 있습니다.
                  </div>
                  <div className="buttons">
                    <input.Button
                      type="button"
                      onClick={() => handlePopup.login()}
                    >
                      로그인
                    </input.Button>
                  </div>
                </>
              ) : (
                <>
                  <div className="popup-guide">
                    구매 후 이용하실 수 있습니다.
                  </div>

                  {/* <div className="buttons">
                  <input.Button
                    type="button"
                    onClick={() => {
                      console.log('구매하러 가기 클릭');
                    }}
                  >
                    구매하러 가기
                  </input.Button>
                </div> */}
                </>
              )
            ) : null}

            <pre
              className="popup-message"
              dangerouslySetInnerHTML={{
                __html: message.title.replace('\\n', '\n'),
              }}
            />

            <input.Text
              key={`consultation-userName`}
              type={'text'}
              name={'userName'}
              value={userName}
              error={error.userName}
              onChange={handleChange}
              placeholder={`신청자 이름`}
              style={{ paddingBottom: '7px' }}
            />
            <input.Text
              key={`consultation-password`}
              type={'text'}
              name={'phoneNumber'}
              value={phoneNumber}
              error={error.phoneNumber}
              onChange={handleChange}
              placeholder={`전화번호`}
              style={{ paddingBottom: '10px' }}
            />

            <div className="question">
              <input.Checkbox
                name={`agree`}
                id={`agree-consultation`}
                value={agree}
                msg={message.checkbox}
                onChange={handleCheckbox}
                style={{ padding: '0' }}
                checkStyle={error.agree ? { borderColor: 'red' } : {}}
              />
            </div>

            <input.BottomButton
              type={'submit'}
              msg={``}
              onClick={handleSubmit}
              buttonStyle={{ backgroundColor: '#9576ea', color: '#fff' }}
            >
              {message.submit}
            </input.BottomButton>
          </form>

          <CloseBtn onClick={handlePopup.close} className={['btn-close']} />
        </div>
      </Dim>
    );
  },
);

export default Consultation;
